import React from 'react';
import Box from '@mui/material/Box';
import { useLayoutContext } from '../../../../utility/AppContextProvider/LayoutContextProvider';
import Typography from '@mui/material/Typography';
import FooterWrapper from './FooterWrapper';

const AppFixedFooter = () => {
  const { footer, footerType } = useLayoutContext();

  return (
    <>
      {footer && footerType === 'fixed' ? (
        <FooterWrapper className='footer fixed-footer'>
          <div className='footerContainer' style={{ height: 55 }}>
            <Typography>&copy; 2024 Joblogic. All rights reserved.</Typography>
            <Box sx={{ ml: 'auto' }}>
              {/* <Button color='primary'>Buy Now</Button> */}
            </Box>
          </div>
        </FooterWrapper>
      ) : null}
    </>
  );
};

export default AppFixedFooter;
